import { FileUpload } from '../fileUpload';


export class FileUploadSerializer {
    fromJson(json: any): FileUpload {
        //debugger;
        const data = new FileUpload();
        data.id = json.id;
        data.fileName = json.fileName;
        data.fileSizeInKB = json.fileSizeInKB,
        data.fileType = json.fileType,
        data.originalFileName = json.originalFileName
        return data;
    }

    toJson(data: FileUpload): any {
        //debugger;
        return {
            id: data.id,
            fileName: data.fileName,
            fileSizeInKB: data.fileSizeInKB,
            fileType: data.fileType,
            originalFileName: data.originalFileName
        };
    }
}